<template>   
<div class="nodata" :style="customStyle">     <img v-if="showObj.img" :src="showObj.img" alt="" />     
<div>{{ showObj.title }}
</div>   
</div> </template>

<script>
/** 缺省页 */
export default {
  props: {
    /** 缺省类型 */
    dataType: {
      type: String,
      default: '0'
    },
    /** 提醒文字 */
    msg: {
      type: String,
      default: ''
    },
    /** 展示图片 */
    img: {
      type: String,
      default: ''
    },
    /** 自定义样式 */
    customStyle: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: {
        0: {
          title: '暂无内容',
          img: require('@/assets/nodata/noData_data.png')
        },
        1: {
          title: '页面找不到了~',
          img: require('@/assets/nodata/noData_404.png')
        },
        2: {
          title: '系统维护',
          img: require('@/assets/nodata/noData_system.png')
        },
        3: {
          title: '暂无搜索内容',
          img: require('@/assets/nodata/noData_search.png')
        },
        4: {
          title: '未添加教材',
          img: require('@/assets/nodata/noData_book.png')
        }
      }
    }
  },
  computed: {
    showObj() {
      let obj = {}
      obj = this.list[this.dataType]
      if (this.msg || this.img) {
        obj = {
          title: this.msg || '暂无内容',
          img: this.img || require('@/assets/nodata/noData_data.png')
        }
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.nodata {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 14px;
  
  font-weight: 400;
  color: #999999;
  user-select: none;
  img {
    pointer-events: none;
    width: 256px;
    height: 176px;
    object-fit: contain;
  }
}
</style>